/**
 * Single source of truth for App Store and Google Play URLs.
 * Override via VITE_APP_STORE_URL and VITE_PLAY_STORE_URL in env.
 */
export const APP_STORE_URL =
  import.meta.env.VITE_APP_STORE_URL ||
  'https://apps.apple.com/us/app/watchsafe/id6758132744';

export const PLAY_STORE_URL =
  import.meta.env.VITE_PLAY_STORE_URL ||
  'https://play.google.com/store/apps/details?id=com.watchsafe.app';
